import React from "react";
import { Modal, Table, Button } from "react-bootstrap";
import { BsCalendar, BsCurrencyDollar, BsCreditCard } from "react-icons/bs";
import { FaUser, FaFileAlt } from "react-icons/fa";
import styles from "../../pages/NSF/Nsf.module.css";
import "./NSFDetailModal.module.css";
import { formatNumbers } from "../../Utils";
import moment from "moment";

const NSFHistoryModal = ({
  show,
  onHide,
  items = [],
  title = "Payment History",
  caseData,
}) => {
  const borrower = caseData?.borrower || "Borrower";
  const loanNumber = caseData?.account || "";
  const maskedAccount = caseData?.BankNumber
    ? `****${String(caseData.BankNumber).slice(-4)}`
    : "";
  const failureDate = caseData?.dateFormatted || caseData?.failureDate || "N/A";
  const amount =
    typeof caseData?.amount === "number"
      ? formatNumbers(caseData.amount)
      : caseData?.Amount != null
      ? formatNumbers(Math.abs(Number(caseData.Amount)))
      : "N/A";

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="nsf-modal">
      <Modal.Header closeButton className="border-0 pb-0 px-4">
        <Modal.Title className="fs-5 fw-semibold m-0">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="nsf-modal-body">
        <div className={`${styles.nsfContainer} pt-3`}>
          {caseData && (
            <div className={`mb-3 ${styles.nsfCard} border-0 shadow-sm p-3`}>
              <div className="d-flex align-items-center">
                <div className={styles.userAvatar}>
                  <FaUser size={24} className="text-secondary" />
                </div>
                <div className="ms-3">
                  <h5 className={styles.borrowerName}>{borrower}</h5>
                  <div className={styles.loanDetails}>
                    <div className="d-flex align-items-center mb-2">
                      <FaFileAlt className="me-2 text-secondary" />
                      <span>Loan: {loanNumber}</span>
                    </div>
                    <div className="d-flex align-items-center flex-wrap">
                      <BsCalendar className="me-2 text-secondary" />
                      <span>NSF Date: {failureDate}</span>
                      <span className="mx-4"></span>
                      <BsCurrencyDollar className="me-2 text-secondary" />
                      <span>{amount}</span>
                      <span className="mx-4"></span>
                      <BsCreditCard className="me-2 text-secondary" />
                      <span>{maskedAccount}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {Array.isArray(items) && items.length > 0 ? (
            <Table
              striped
              bordered
              hover
              responsive
              className="mb-0 mt-3 nsf-history-table"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>NSF Date</th>
                  <th>Amount</th>
                  <th>Account</th>
                </tr>
              </thead>
              <tbody>
                {[...items]
                  .sort((a, b) => {
                    const dateA = moment(
                      a.dateFormatted,
                      "MM-DD-YYYY"
                    ).toDate();
                    const dateB = moment(
                      b.dateFormatted,
                      "MM-DD-YYYY"
                    ).toDate();
                    return dateB - dateA; // Sort in descending order (newest first)
                  })
                  .map((it, idx) => (
                    <tr key={it.id || idx}>
                      <td>{idx + 1}</td>
                      <td>{it.dateFormatted || "N/A"}</td>
                      <td>
                        {typeof it.amount === "number"
                          ? formatNumbers(Math.abs(it.amount))
                          : it.amount}
                      </td>
                      <td>
                        {it.account ||
                          `****${String(it.accountLast4 || "").slice(-4)}`}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          ) : (
            <div className="text-center text-muted py-5">No history found.</div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0 px-4 pb-4">
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NSFHistoryModal;
